import React from 'react'
import '../Common.scss';
import defaultImage from '../../../assets/default.png';


export default function FalseCeilingLightingView({pageDetails}) {
  const {images,metaData}=pageDetails
  let lightsArrays = [];
  let lightKeys= []
  if(metaData.falseCeilingLightingData.length>0){
    lightKeys=Object.keys(metaData.falseCeilingLightingData[0])
    let metaDataLights= Array.from(metaData.falseCeilingLightingData);
  
    let parts=metaData.falseCeilingLightingData.length/4;
    
    for (let i = parts; i > 0; i--) {
      lightsArrays.push(metaDataLights.splice(0, Math.ceil(metaDataLights.length / i)));
    }
  }

  return (
    <React.Fragment>
    <div className="page-image-container">
        <div className="page-heading">{pageDetails?.name}</div>
        <div className="image-section-container">
            <img crossOrigin="anonymous" src={images ? images[0].imageUrl : defaultImage} alt="" className="image-view" />
        </div>
    </div>
    {lightsArrays.length>0 ? 
    <>
      <div className="details-heading-wrapper details-heading">
        LIGHT SPECIFICATIONS
      </div>
      <div className="details">
      {lightsArrays.map((lightsArray,index1)=>{
      return <div className="details-table"  style={{marginRight:"250px"}}  key={index1}>
              <React.Fragment>
                  <div className="table-row" style={{width:"400px"}}>
                      {
                        lightKeys.map((heading,index2)=>{
                            let nameWidth= heading==="description" ? "40%" : "20%"
                            return <div className="table-cell color-heading" key={index2} style={{width:nameWidth}}>
                                {heading.toString().toUpperCase()}
                            </div>
                        })
                      }
                  </div>
              </React.Fragment> 
              {lightsArray.map((arrObj, index) => {
                return (
                    <React.Fragment key={index}>
                        {
                          <div className="table-row" style={{width:"400px",marginRight:"10px"}}>
                              <div className="table-cell" style={{width:"20%"}}>
                                  {arrObj.caption}
                              </div>
                              <div className="table-cell" style={{width:"40%"}}>
                                 {arrObj.description}
                              </div>
                              <div className="table-cell" style={{width:"20%"}}>
                                  {arrObj.socketType ? arrObj.socketType : "NA"}
                              </div>   
                              <div className="table-cell" style={{width:"20%"}}>
                                  {arrObj.moduleType?arrObj.moduleType:"NA"}
                              </div>
                               <div className="table-cell" style={{width:"20%"}}>
                                  {arrObj.pointType ? arrObj.pointType : "NA"}
                              </div>
                              <div className="table-cell" style={{width:"20%"}}>
                                  {arrObj.type ? arrObj.type : "NA"}
                              </div>
                              <div className="table-cell" style={{width:"20%"}}>
                                  {arrObj.uom ? arrObj.uom : "NA"}
                              </div>
                          </div>
                        }
                    </React.Fragment>
                );
            })}
          </div>
        })}
        </div>
    </> : null}
    </React.Fragment>
  )
}
